<template>
  <div class="form-group">
    <label class="idx-bold"
      >{{ $t('newAction.stepOne.labels.question') }}
    </label>
    <span id="popover-main-question">
      <font-awesome-icon
        :icon="['fas', 'info-circle']"
        style="font-size: 15px; color: #c1c1c1;"
      />
    </span>

    <b-popover target="popover-main-question" triggers="hover" placement="top">
      <span>{{ $t('newAction.stepOne.labels.infoQuestion') }}</span>
    </b-popover>
    <template v-if="this.$store.state.actions.metric === 'NPS'">
      <input
        type="text"
        id="question-id"
        class="form-control"
        v-model="action.question"
        :maxlength="maxLenght"
        :disabled="disabled"
      />
    </template>
    <template v-else>
      <input
        type="text"
        id="question-id"
        class="form-control"
        v-model="action.question"
        :maxlength="maxLenght"
        :disabled="disabled"
      />
    </template>
    <div class="invalid-feedback">
      {{ $t('newAction.stepOne.feedbackEnterOneQuestion') }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data: () => ({
    question: null,
    maxLenght: null,
    disabled: true,
  }),
  computed: {
    ...mapFields('actions', ['action', 'isEditAction']),
    ...mapState('companies', ['myMetric', 'company']),
  },
  watch: {
    'action.sms.config': function watchActionConfig(value) {
      if (value === 'body') {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },

    'action.type': function watchMyMethodology() {
      this.setQuestion();
    },

    '$i18n.locale': function watchLocale() {
      if (!this.action._id) {
        this.setQuestion();
      }
    },
    '$store.state.actions.action.channel': function watchChannel() {
      if (this.$store.state.actions.action.channel === 'sms') {
        this.maxLenght = 160;
      }
    },
  },
  methods: {
    setQuestion() {
      // if (this.action.type === 'nps-0-10' || !this.action.type) {
      //   this.action.question = this.$t('newAction.stepOne.scale0a10', {
      //     companyName: `${this.company.name}`,
      //   });
      // } else if (this.action.type === 'nps-1-5') {
      //   this.action.question = this.$t('newAction.stepOne.scale1a5', {
      //     companyName: `${this.company.name}`,
      //   });
      // } else if (this.action.type === 'ces-1-5') {
      //   this.action.question = this.$t('newAction.stepOne.scaleCES1a5');
      // } else if (this.action.type === 'csat-1-5') {
      //   this.action.question = this.$t('newAction.stepOne.scaleCSAT1to5');
      // }
    },
  },
  mounted() {
    if (!this.action.question) {
      this.setQuestion();
    }

    if (this.action.sms.config === 'body') {
      this.disabled = false;
    } else {
      this.disabled = true;
    }

    if (this.$store.state.actions.action.channel === 'sms') {
      this.maxLenght = 160;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/question/index.vue